import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import NeemContactOp from "./sections/NeemContactOp";
import OurRegion from "./sections/OurRegion";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <NeemContactOp />
      <OurRegion />
      <Footer />
    </div>;
}